import React, { useState, useEffect } from 'react';

const DEFAULT_COLUMNS = { default: 3, 1200: 3, 768: 2, 480: 1 };

export default function CustomMasonry({
                                        children,
                                        columns = DEFAULT_COLUMNS,
                                        gap = '15px',
                                        className = '',
                                      }) {
  const [columnCount, setColumnCount] = useState(typeof columns === 'number' ? columns : columns.default);

  useEffect(() => {
    if (typeof columns === 'number') return;

    const handleResize = () => {
      const width = window.innerWidth;
      // Sort breakpoints in descending order (e.g., 1200, 992, 768...)
      const sortedBreakpoints = Object.keys(columns)
        .filter((key) => key !== 'default')
        .map(Number)
        .sort((a, b) => b - a);

      let matchedColumns = columns.default;
      for (const breakpoint of sortedBreakpoints) {
        if (width <= breakpoint) {
          matchedColumns = columns[breakpoint];
        }
      }
      setColumnCount(matchedColumns);
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Initial check

    return () => window.removeEventListener('resize', handleResize);
  }, [columns]);

  // Create empty arrays for each column
  const columnStrands = Array.from({ length: columnCount }, () => []);

  // Distribute the children flatly (and filter out falsy values) from left to right
  const flatChildren = React.Children.toArray(children).filter(Boolean);
  flatChildren.forEach((child, index) => {
    columnStrands[index % columnCount].push(child);
  });

  return (
    <div className={`custom-masonry-grid ${className}`} style={{ display: 'flex', width: '100%', gap }}>
      {columnStrands.map((colChildren, idx) => (
        <div
          key={idx}
          className="custom-masonry-column"
          style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            gap,
          }}
        >
          {colChildren}
        </div>
      ))}
    </div>
  );
}
